import { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import { useHistory, useLocation } from 'react-router-dom';
import { convertDateToUTC } from '../utils/stringManipulation';

interface Props {
  onDateChange: (a: any, b?: boolean) => void;
}

const CCalendar = ({ onDateChange }: Props) => {
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const fromParam = params.get('from');
    const toParam = params.get('to');

    const fromDate = fromParam ? new Date(fromParam) : new Date();
    const toDate = toParam ? new Date(toParam) : new Date();

    const formattedDates = [convertDateToUTC(new Date(fromDate)), convertDateToUTC(new Date(toDate))];

    setDateRange(formattedDates);
    onDateChange(formattedDates, true);
  }, []);

  const history = useHistory();
  const location = useLocation();

  const onChange = (values: Date[]) => {
    history.replace({
      pathname: location.pathname,
      search: '',
    });

    const newRange = values.length === 1 ? [values[0], values[0]] : values;
    setDateRange(newRange);
    onDateChange(newRange, true);
  };

  return (
    <Calendar
      onChange={onChange}
      calendarType="US"
      value={dateRange}
      allowPartialRange
      selectRange
    />
  );
};

export default CCalendar;
